import { render, staticRenderFns } from "./depositList.vue?vue&type=template&id=0d046e96&scoped=true&"
import script from "./depositList.vue?vue&type=script&lang=js&"
export * from "./depositList.vue?vue&type=script&lang=js&"
import style0 from "./depositList.vue?vue&type=style&index=0&id=0d046e96&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d046e96",
  null
  
)

export default component.exports